import React, { Component } from 'react';
import { getBanksList } from '../../actions/bankActions';

export const BankContext = React.createContext(null);

export class BankProvider extends Component {
  constructor(props) {
    super(props);
    
    // Try to get bank_id from URL or localStorage
    const urlParams = new URLSearchParams(window.location.search);
    const urlBankId = urlParams.get('bank_id');
    const storedBankId = localStorage.getItem('selectedBankId');
    const initialBankId = urlBankId || storedBankId || null;
    
    this.state = {
      selectedBank: initialBankId ? parseInt(initialBankId) : null,
      banks: [],
      loading: false
    };
  }

  componentDidMount() {
    // Load banks list
    this.loadBanks();
  }

  loadBanks = () => {
    this.setState({ loading: true });
    getBanksList().then(({ items }) => {
      this.setState({ banks: items, loading: false });
    }).catch(error => {
      console.error('Error loading banks:', error);
      this.setState({ loading: false });
    });
  };

  setSelectedBank = (bankId) => {
    const parsedBankId = bankId ? parseInt(bankId) : null;
    this.setState({ selectedBank: parsedBankId });
    
    // Store in localStorage for persistence
    if (parsedBankId) {
      localStorage.setItem('selectedBankId', parsedBankId);
    } else {
      localStorage.removeItem('selectedBankId');
    }
    
    // Update URL to reflect selected bank
    if (parsedBankId) {
      const currentPath = window.location.pathname;
      const newUrl = `${currentPath}?bank_id=${parsedBankId}`;
      window.history.replaceState(null, '', newUrl);
    }
  };

  render() {
    const contextValue = {
      selectedBank: this.state.selectedBank,
      banks: this.state.banks,
      loading: this.state.loading,
      setSelectedBank: this.setSelectedBank,
      loadBanks: this.loadBanks
    };

    return (
      <BankContext.Provider value={contextValue}>
        {this.props.children}
      </BankContext.Provider>
    );
  }
}
